module.exports = __webpack_public_path__ + "img/school.66fa5eac.png";